export const PAGE_SIZE = 10;
